import { NormalEdit } from './normal-edit';
/**
 * `InlineEdit` module is used to handle inline editing actions.
 *
 * @hidden
 */
export class InlineEdit extends NormalEdit {
    constructor(parent, serviceLocator, renderer) {
        super(parent, serviceLocator);
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.renderer = renderer;
    }
    closeEdit() {
        super.closeEdit();
    }
    addRecord(data, index) {
        super.addRecord(data, index);
    }
    endEdit() {
        super.endEdit();
    }
    updateRow(index, data) {
        super.updateRow(index, data);
    }
    deleteRecord(fieldname, data) {
        super.deleteRecord(fieldname, data);
    }
    startEdit(tr) {
        super.startEdit(tr);
    }
}
